export default __webpack_public_path__ + "static/assets/405df25772d831074eb12a529c70e859.png";